import client from './client';

export const getInvoiceImportsPaginated = (params) =>
  client.get('/invoice-imports', { params }).then((r) => r.data);

export const getInvoiceImport = (uuid) =>
  client.get(`/invoice-imports/${uuid}`).then((r) => r.data);

export const uploadInvoiceImport = (formData) =>
  // Do NOT set Content-Type manually: the browser must generate the
  // `multipart/form-data; boundary=...` header itself. Hardcoding it without the
  // boundary makes the backend multipart parser fail with "Unexpected end of form".
  client.post('/invoice-imports', formData).then((r) => r.data);

export const updateInvoiceImport = (uuid, data) =>
  client.patch(`/invoice-imports/${uuid}`, data).then((r) => r.data);

export const confirmInvoiceImport = (uuid, data) =>
  client.post(`/invoice-imports/${uuid}/confirm`, data).then((r) => r.data);

export const retryInvoiceImport = (uuid, businessUuid) =>
  client
    .post(`/invoice-imports/${uuid}/retry`, { businessUuid })
    .then((r) => r.data);

export const deleteInvoiceImport = (uuid, businessUuid) =>
  client
    .delete(`/invoice-imports/${uuid}`, { params: { businessUuid } })
    .then((r) => r.data);

/**
 * Fetches a protected page image through the authenticated axios client and
 * returns an object URL. Used on web, where <img> cannot send auth headers.
 */
export const fetchPageImageObjectUrl = async (uuid, index) => {
  const response = await client.get(`/invoice-imports/${uuid}/pages/${index}`, {
    responseType: 'blob',
  });
  return URL.createObjectURL(response.data);
};

/**
 * Fetches the original uploaded file as an authenticated blob and returns an
 * object URL plus its mime type. Used to open in a new tab or download.
 */
export const fetchOriginalFileObjectUrl = async (uuid, download = false) => {
  const response = await client.get(`/invoice-imports/${uuid}/original`, {
    params: download ? { download: 1 } : undefined,
    responseType: 'blob',
  });
  const blob = response.data;
  return { url: URL.createObjectURL(blob), mimeType: blob.type };
};
